module.exports = __webpack_public_path__ + "static/media/pdf.a9b7a20e.png";